import Marquee from "react-fast-marquee";

const words = ["Partial Service", "Full Service", "Private Chef", "Corporate Events", "Seasonal Menus"];

export default function BrandMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="py-12 md:py-16 border-y border-[#F5F2EB]/10 bg-[#0a0a0a]/40"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-4xl md:text-7xl font-light text-[#B5643C]/70 px-8">
              {w}
            </span>
            <span className="text-[#B5643C]/40 text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
